import type { TFunction } from 'i18next';

import { serverErrorCode } from '@/lib/serverErrorCode';

/**
 * Map server error tokens to friendly titles + detail text. The server
 * surfaces machine-readable strings via `data.error`; we translate the
 * common ones so users see something actionable instead of a raw token.
 */
export function errorTitleFor(raw: string | null, t: TFunction): string {
  if (!raw) return t('editor.step6.errors.generic');
  const code = serverErrorCode(raw);
  if (code === 'video2d_unavailable')            return t('editor.step6.errors.unavailable');
  if (code === 'avatar_creation_reserved')       return t('editor.step6.errors.creationReserved');
  if (code === 'user_daily_video2d_cap')         return t('editor.step6.errors.dailyCap');
  if (code === 'too_many_concurrent_videos')     return t('editor.step6.errors.tooMany');
  if (code === 'avatar_video_capacity_reached')  return t('editor.step6.errors.capacity');
  if (code === 'prompt_too_short')               return t('editor.step6.errors.promptShort');
  if (code === 'prompt_too_long')                return t('editor.step6.errors.promptLong');
  if (code === 'no_source_image')                return t('editor.step6.errors.noImage');
  if (code === 'avatar_not_active')              return t('editor.step6.errors.notActive');
  return t('editor.step6.errors.generic');
}

export function errorDetailFor(raw: string | null, t: TFunction): string | undefined {
  if (!raw) return undefined;
  const code = serverErrorCode(raw);
  if (code === 'video2d_unavailable')            return t('editor.step6.errors.unavailableDetail');
  if (code === 'avatar_creation_reserved')       return t('editor.step6.errors.creationReservedDetail');
  if (code === 'user_daily_video2d_cap')         return t('editor.step6.errors.dailyCapDetail');
  if (code === 'too_many_concurrent_videos')     return t('editor.step6.errors.tooManyDetail');
  if (code === 'avatar_video_capacity_reached')  return t('editor.step6.errors.capacityDetail');
  if (code === 'prompt_too_short')               return t('editor.step6.errors.promptShortDetail');
  if (code === 'prompt_too_long')                return t('editor.step6.errors.promptLongDetail');
  // Un messaggio del server (o il ripiego tradotto sopra): si mostra com'è.
  return raw;
}
